module.exports = __webpack_public_path__ + "img/20210818115800623iw1.52b9aba0.png";